import { CatHeading } from '@blocks-react/components/Heading';
import { ProductCardDescriptionProps } from '../types';

export const ProductCardDescription = ({
  children
}: ProductCardDescriptionProps) => {
  return <CatHeading variant="body-sm">{children}</CatHeading>;
};
